export default __webpack_public_path__ + "static/media/about_us_1.07c5fb87.jpg";